import { render, staticRenderFns } from "./ProcessManage.vue?vue&type=template&id=31968728&scoped=true&"
import script from "./ProcessManage.vue?vue&type=script&lang=js&"
export * from "./ProcessManage.vue?vue&type=script&lang=js&"
import style0 from "./ProcessManage.vue?vue&type=style&index=0&id=31968728&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31968728",
  null
  
)

export default component.exports